// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationBar2PlusItems_container___4Jli","compactLayout":"NotificationBar2PlusItems_compactLayout__CzjH7"};